export const formatAddress = (addressObj) => {
  const formattedBlockNo = addressObj.blockNo ?? ''
  const formattedStreetName = addressObj.streetName ?? ''
  const formattedBuildingName = addressObj.buildingName ?? ''
  const formattedPostalCode = addressObj.postalCode ?? ''
  return `${formattedBlockNo} ${formattedStreetName} ${formattedBuildingName} SINGAPORE ${formattedPostalCode}`
}
